/**
 * Query params that may carry personal data. They must never reach GA4
 * (page_location, noscript pixel) — STAA-44.
 */
const PII_PARAMS = new Set([
  'email',
  'e-mail',
  'mail',
  'customer_email',
  'customeremail',
  'phone',
  'tel',
  'token',
  'password',
  'firstname',
  'lastname',
  'name',
  'address',
])

/**
 * Remove PII query params from a URL (absolute, or path + query).
 * `?email=a@b.at&success=true` -> `?success=true`.
 * Also drops any param whose value looks like an e-mail address.
 */
export function sanitizeAnalyticsUrl(url: string): string {
  if (!url) return url
  const hashIndex = url.indexOf('#')
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : ''
  const withoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url
  const qIndex = withoutHash.indexOf('?')
  if (qIndex < 0) return url

  const base = withoutHash.slice(0, qIndex)
  const params = new URLSearchParams(withoutHash.slice(qIndex + 1))
  const kept = new URLSearchParams()
  params.forEach((value, key) => {
    if (PII_PARAMS.has(key.toLowerCase())) return
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return
    kept.append(key, value)
  })
  const qs = kept.toString()
  return `${base}${qs ? `?${qs}` : ''}${hash}`
}
